import React, { FC, useEffect } from 'react';
import { useMetasiteError } from '../context/errors';
import { useBiLogger } from '../hooks/useBiLogger/useBiLogger';
import { GeneralError } from '../components/GeneralError/GeneralError';
import { StoreNameRoot } from '../features/storeName';
import { useMsIdAtomValue, useCurrentCategoryValue } from '../context';
import { SelectThemeFirst } from '../experiments';
import { useSpec } from '../hooks/useSpec';
import { Box, Loader } from '@wix/design-system';
import { useLocalStorageSync } from '../hooks/useLocalStorageSync';
import { DsBuilderMethod } from '../types';

export const StoreName: FC = () => {
  const metasiteError = useMetasiteError();
  const biLogger = useBiLogger();
  const msId = useMsIdAtomValue();
  const currentCategoryValue = useCurrentCategoryValue();
  const shouldSelectThemeFirst = useSpec(SelectThemeFirst);

  const { isLoading } = useLocalStorageSync();

  useEffect(() => {
    biLogger.pageView(DsBuilderMethod[DsBuilderMethod.STORE_NAME]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <Box height="100%" width="100%" align="center" verticalAlign="middle">
        <Loader />
      </Box>
    );
  }

  if ((!shouldSelectThemeFirst && !msId) || !currentCategoryValue) {
    return;
  }

  if (metasiteError) {
    return <GeneralError />;
  }

  return <StoreNameRoot />;
};
